document.addEventListener('DOMContentLoaded', () => {
  const details = document.querySelector('.custom-tabs-dropdown');
  const nav = details?.querySelector('nav');

  if (!details || !nav) return;

  // FUNZIONE per bloccare/riattivare scroll
  function toggleScroll(open) {
    document.body.style.overflow = open ? 'hidden' : '';
    document.documentElement.style.overflow = open ? 'hidden' : '';
  }

  // Gestione click sul summary (per chiusura animata)
  details.addEventListener('click', (e) => {
    const isSummary = e.target.closest('summary');
    if (!isSummary) return;

    if (details.open) {
      // blocca chiusura immediata
      e.preventDefault();

      // imposta maxHeight prima della chiusura
      nav.style.maxHeight = nav.scrollHeight + 'px';

      // attiva animazione chiusura
      requestAnimationFrame(() => {
        nav.style.maxHeight = '0';
        nav.style.opacity = '0';
        nav.style.transform = 'translateY(-8px)';
      });

      // chiudi davvero dopo la transition
      setTimeout(() => {
        details.removeAttribute('open');
        toggleScroll(false);
      }, 750); // deve combaciare con la transition
    }
  });

  // Apertura normale
  details.addEventListener('toggle', () => {
    if (details.open) {
      nav.style.maxHeight = nav.scrollHeight + 'px';
      nav.style.opacity = '1';
      nav.style.transform = 'translateY(0)';
      toggleScroll(true);
    } else {
      toggleScroll(false);
    }
  });
});